/* ============================================================
   AVORA HOME — Scroll Animation System
   IntersectionObserver-driven fade-up entrance animations
   with stagger support via data-avora-delay
   ============================================================ */

(function initScrollAnimations() {
  /* Inject animation styles */
  var style = document.createElement('style');
  style.textContent =
    '[data-avora-animate].avora-pending{' +
      'opacity:0;' +
      'transform:translateY(20px);' +
      'transition:opacity 0.6s cubic-bezier(0.25,0.1,0.25,1),' +
                  'transform 0.6s cubic-bezier(0.25,0.1,0.25,1);' +
    '}' +
    '[data-avora-animate].avora-visible{' +
      'opacity:1;' +
      'transform:translateY(0);' +
    '}' +
    /* Respect reduced motion preferences */
    '@media(prefers-reduced-motion:reduce){' +
      '[data-avora-animate]{opacity:1;transform:none;transition:none;}' +
    '}';
  document.head.appendChild(style);

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var delay = parseInt(entry.target.dataset.avoraDelay, 10) || 0;
        if (delay > 0) {
          setTimeout(function() {
            entry.target.classList.add('avora-visible');
          }, delay);
        } else {
          entry.target.classList.add('avora-visible');
        }
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  function observeElements() {
    var elements = document.querySelectorAll('[data-avora-animate]:not(.avora-visible)');
    // Read before writing: visible content never waits for reveal timers or scripts.
    var visible = Array.from(elements, function(el) { return el.getBoundingClientRect().top < window.innerHeight; });
    elements.forEach(function(el, index) {
      if (visible[index]) el.classList.add('avora-visible');
      else { el.classList.add('avora-pending'); observer.observe(el); }
    });
  }

  /* Run on DOMContentLoaded and also on any Shopify section re-render */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  /* Re-observe when Shopify editor loads/reloads sections */
  document.addEventListener('shopify:section:load', observeElements);
})();
